<template>
    <div>
        <p class="text-body-2 mb-4">
            Revisa la información antes de iniciar la carga. Esta operación es irreversible.
        </p>

        <v-list density="compact" class="mb-4">
            <v-list-item>
                <template v-slot:prepend>
                    <v-icon class="mr-2">mdi-file-excel</v-icon>
                </template>
                <v-list-item-title>Archivo</v-list-item-title>
                <v-list-item-subtitle>{{ filename }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
                <template v-slot:prepend>
                    <v-icon class="mr-2">mdi-table-column</v-icon>
                </template>
                <v-list-item-title>Columnas mapeadas</v-list-item-title>
                <v-list-item-subtitle>{{ mappedCount }} de {{ mapping.length }} campos</v-list-item-subtitle>
            </v-list-item>
        </v-list>

        <div v-if="samples.length">
            <div class="text-subtitle-2 mb-2">Muestra de registros</div>
            <div class="sample_container">
                <table class="sample_table">
                    <thead>
                        <tr>
                            <th v-for="column in providedColumns" :key="column.index">{{ columnTitle(column) }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, rowIndex) in samples" :key="rowIndex">
                            <td v-for="column in providedColumns" :key="column.index">{{ row[column.index] ?? '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="d-flex justify-space-between mt-6">
            <v-btn variant="outlined" color="indigo-darken-3" text="Atrás" :disabled="loading" @click="$emit('back')"></v-btn>
            <v-btn
                variant="flat"
                color="indigo-darken-3"
                text="Confirmar importación"
                :loading="loading"
                :disabled="loading"
                @click="$emit('confirm')"
            ></v-btn>
        </div>
    </div>
</template>

<script>
    import { excelColumnLabel } from '@/utils/excelColumn';

    export default {
        name: 'ImportConfirmStep',
        props: {
            filename: {
                type: String,
                default: '',
            },
            mapping: {
                type: Array,
                default: () => [],
            },
            providedColumns: {
                type: Array,
                default: () => [],
            },
            samples: {
                type: Array,
                default: () => [],
            },
            loading: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            columnTitle (column) {
                const letter = excelColumnLabel(column.index);
                return column.name ? `${column.name} (${letter})` : `Columna ${letter}`;
            },
        },
        computed: {
            mappedCount () {
                return this.mapping.filter((field) => {
                    return field.providedIndex !== null && field.providedIndex !== undefined;
                }).length;
            },
        },
    };
</script>

<style scoped>
    .sample_container {
        max-height: 220px;
        overflow: auto;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }

    .sample_table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }

    .sample_table th,
    .sample_table td {
        padding: 6px 8px;
        border-bottom: 1px solid #f0f0f0;
        text-align: left;
        white-space: nowrap;
    }

    .sample_table th {
        position: sticky;
        top: 0;
        background: #fafafa;
    }
</style>
